/* MEALUP header behaviour.
   1. Transparent header: transparent over the first section, espresso once the visitor scrolls.
      The transparent state itself is pure CSS (mu-core.css, keyed on [data-mu-transparent]),
      so there is no flash before this runs. This adds html.mu-scrolled after the first few
      pixels of scroll and keeps --mu-header-h equal to the real header height.
   2. Announcement ticker: constant speed in px per second (section setting), and the pause button.
   3. Header CTA on a product page: scrolls to the buy box of the product on the page instead of
      reloading it, so the visitor keeps the flavor and purchase option already chosen. */
(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1. transparent header */
  (function () {
    var wrapper = document.querySelector('.header-wrapper[data-mu-transparent]');
    if (!wrapper) return;
    var section = wrapper.closest('.section-header') || wrapper;

    function measure() {
      // measure only in the top state, where the logo is full size
      if (root.classList.contains('mu-scrolled')) return;
      root.style.setProperty('--mu-header-h', section.offsetHeight + 'px');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        root.classList.toggle('mu-scrolled', window.scrollY > 8);
        ticking = false;
      });
    }

    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  })();

  /* 2. announcement ticker */
  (function () {
    var bar = document.querySelector('[data-mu-ann]');
    if (!bar) return;
    var set = bar.querySelector('.mu-ann__set');
    var toggle = bar.querySelector('.mu-ann__toggle');
    var speed = parseFloat(bar.getAttribute('data-speed')) || 36;

    function setDuration() {
      if (!set || !set.offsetWidth) return;
      bar.style.setProperty('--mu-ann-dur', (set.offsetWidth / speed).toFixed(2) + 's');
    }
    setDuration();
    window.addEventListener('resize', setDuration);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setDuration);

    if (toggle) {
      toggle.addEventListener('click', function () {
        var paused = bar.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', toggle.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      });
    }
  })();

  /* 3. header CTA scrolls to the buy box on product pages */
  (function () {
    var cta = document.querySelector('[data-mu-header-cta]');
    if (!cta) return;

    function buyBox() {
      var form = document.querySelector('[data-mu-buybox]') ||
        document.querySelector('#MainContent form[action*="/cart/add"][id^="product-form-"][id*="__main"]') ||
        document.querySelector('#MainContent form[action*="/cart/add"][id^="product-form-"]') ||
        document.querySelector('#MainContent product-form form[action*="/cart/add"]');
      if (!form) return null;
      if (form.hasAttribute('data-mu-buybox')) return form;
      var info = form.closest('.product__info-container, .product__info-wrapper, product-info') || form;
      // start the view at the flavor picker when there is one, so the choice and the button are on screen together
      return info.querySelector('variant-selects, variant-radios, .product-form__input--pill') || form;
    }

    cta.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = buyBox();
      if (!target) return;
      event.preventDefault();
      var header = document.querySelector('.section-header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth' });
      // move keyboard and screen reader focus to the buy box without a second jump
      var focusEl = target.querySelector('input[type="radio"]:checked') || target;
      if (focusEl === target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); }
    });
  })();
})();
